import React from "react";
import { Calendar, MapPin } from "lucide-react";
import { bandData } from "../mock";

const Shows = () => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  };

  return (
    <section id="shows" className="py-20 bg-[#0a0a0f]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Upcoming Shows
          </h2>
          <div className="w-24 h-1 bg-[#00d9ff] mx-auto mb-6" />
          <p className="text-xl text-white/80">
            Catch us live in 2026!
          </p>
        </div>

        {/* Shows List */}
        <div className="space-y-6 max-w-3xl mx-auto">
          {bandData.upcomingShows.map((show) => (
            <div
              key={show.id}
              className="bg-[#1a1a2e] rounded-lg p-6 hover:bg-[#222236] transition-all border-l-4 border-[#ff6b35]"
            >
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <Calendar size={24} className="text-[#00d9ff]" />
                  <p className="text-xl font-bold text-white">
                    {formatDate(show.date)}
                  </p>
                </div>
                <div className="flex items-center gap-3 mb-2">
                  <MapPin size={24} className="text-[#ff6b35]" />
                  <div>
                    <p className="text-lg text-white/90 font-semibold">{show.venue}</p>
                    <p className="text-white/60">{show.city}</p>
                  </div>
                </div>
                {show.time && (
                  <div className="flex items-center gap-3 ml-11">
                    <p className="text-white/80">
                      <span className="font-medium">Time:</span> {show.time}
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Booking CTA */}
        <div className="mt-12 text-center">
          <p className="text-white/80 text-lg mb-6">
            Want to book Searching Fusion for your venue or event?
          </p>
          <a
            href="#booking"
            onClick={(e) => {
              e.preventDefault();
              const element = document.getElementById("booking");
              if (element) element.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-block bg-[#ff6b35] hover:bg-[#d1503a] text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg hover:shadow-xl"
          >
            Get in Touch
          </a>
        </div>
      </div>
    </section>
  );
};

export default Shows;
